module.exports = __webpack_public_path__ + "static/media/photo7@2x.2c13b1f8.jpg";